export default "/assets/webpack-assets/voucher-story.67b13c36ea76e989c1d6982f999d866b.jpg";